
import { ReactComponent as LuwangSvg } from '@/commons/icons/new/luwang.svg';
import { ReactComponent as DaoluSvg } from '@/commons/icons/new/daolu.svg';
import { ReactComponent as LudengSvg } from '@/commons/icons/new/ludeng.svg';
import { ReactComponent as WeiqiangSvg } from '@/commons/icons/new/weiqiang.svg';
import { ReactComponent as DimianSvg } from '@/commons/icons/new/dimian.svg';
import { ReactComponent as JidongcheweiSvg } from '@/commons/icons/new/jidongchechewei.svg';
import { ReactComponent as FeijidongcheweiSvg } from '@/commons/icons/new/feijidongchechewei.svg';
import { ReactComponent as QiaoguanmuSvg } from '@/commons/icons/new/qiaoguanmu.svg';
import { ReactComponent as JiaochakouSvg } from '@/commons/icons/new/jiaochakou.svg';
import { graphicStore } from '@/commons/store/graphic-store';
import { SideStatus } from '@/commons/context/side-store';
import { SideContext, SystemContext } from '@/App';
import { useContext, useEffect, useRef, useState } from 'react';
import { SIDE_TYPE } from '@/commons/enums/side-type';

import { ReactComponent as CaodiSvg } from '@/commons/icons/menu/planning/caodi.svg';
import { ReactComponent as ChurukouSvg } from '@/commons/icons/menu/planning/churukou.svg';
import { ReactComponent as DenggaoxianSvg } from '@/commons/icons/menu/planning/denggaoxian.svg';
import { ReactComponent as GengdiSvg } from '@/commons/icons/menu/planning/gengdi.svg';
import { ReactComponent as GouzhuwuSvg } from '@/commons/icons/menu/planning/gouzhuwu.svg';
import { ReactComponent as HandongSvg } from '@/commons/icons/menu/planning/handong.svg';
import { ReactComponent as HeliuSvg } from '@/commons/icons/menu/planning/heliu.svg';
import { ReactComponent as HupoSvg } from '@/commons/icons/menu/planning/hupo.svg';
import { ReactComponent as JianzhuwuSvg } from '@/commons/icons/menu/planning/jianzhuwu.svg';
import { ReactComponent as LinshidaoluSvg } from '@/commons/icons/menu/planning/linshidaolu.svg';

import { ReactComponent as ZhaozeSvg } from '@/commons/icons/menu/planning/zhaoze.svg';
import { ReactComponent as SuidaoSvg } from '@/commons/icons/menu/planning/suidao.svg';
import { ReactComponent as ShulinSvg } from '@/commons/icons/menu/planning/shulin.svg';
import { ReactComponent as ShanSvg } from '@/commons/icons/menu/planning/shan.svg';
import { ReactComponent as ShamoSvg } from '@/commons/icons/menu/planning/shamo.svg';
import { ReactComponent as QiaoliangSvg } from '@/commons/icons/menu/planning/qiaoliang.svg';
import { ReactComponent as LinshiweidangSvg } from '@/commons/icons/menu/planning/linshiweidang.svg';
import { ReactComponent as LinshifangwuSvg } from '@/commons/icons/menu/planning/linshifangwu.svg';
import { ReactComponent as GaochengdianSvg } from '@/commons/icons/menu/planning/gaochengdian.svg';
import { ReactComponent as UploadBlackSvg } from "@/commons/icons/panel-icon/upload-black.svg";


import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { SystemStatus } from '@/commons/context/system-store';
import { ObjMeshGroupMoveControl } from '@/plugin/subcontrol/ObjMeshGroupMoveControl';
import { getObjFiles, resolveObjFiles, updateObjFiles, uploadFileObject } from '@/api/project/file';
import { Button, Form, message, Select } from 'antd';
import { EXTRA_SINGAL } from '@/commons/enums/extra-singal';
import { ObjFile, Point4 } from '@/commons/interface/geometry/obj-file';
import { useParams } from 'react-router-dom';
import genUUID from '@/commons/utils/gen-uuid';
import ConfirmModal from '@/commons/widget/monix-modal';
import { Storey } from '@/commons/interface/building/storey';
import { getStoreys } from '@/api/building/storey';

interface ObjModelInfo {
    objUrl: string;
    position?: Point4;
    scale?: Point4;
    rotation?: Point4;
    uuid?: string;
}


export default function PlanningMenu() {
    const sideContext = useContext<SideStatus>(SideContext);
    const systemContext = useContext<SystemStatus>(SystemContext);
    const { projectUuid, modelUuid } = useParams();

    const updateObjFileMulti = () => {
        if (systemContext.objFiles) {
            const files = [];
            systemContext.objFiles.forEach(obj => {
                const objUuid = systemContext.currentObjMeshGroupUuidMap[obj.uuid];
                if (!objUuid) return;
                const objMeshGroup = findObjMeshGroup(objUuid);
                let tmpObjFile: ObjFile = { ...obj };
                tmpObjFile.position = { x: objMeshGroup.position.x, y: objMeshGroup.position.y, z: objMeshGroup.position.z };
                tmpObjFile.rotation = { x: objMeshGroup.quaternion.x, y: objMeshGroup.quaternion.y, z: objMeshGroup.quaternion.z, w: objMeshGroup.quaternion.w };
                tmpObjFile.scale = { x: objMeshGroup.scale.x, y: objMeshGroup.scale.y, z: objMeshGroup.scale.z };
                files.push(tmpObjFile);
            })
            updateObjFiles(files);
        }
    }

    useEffect(() => {
        graphicStore.extraContext.listeners.getSignal(EXTRA_SINGAL.onObjMeshGroupChange).add(updateObjFileMulti);
        return () => {
            graphicStore.extraContext.listeners.getSignal(EXTRA_SINGAL.onObjMeshGroupChange).remove(updateObjFileMulti);
        }
    }, [systemContext.currentObjMeshGroupUuids, systemContext.objFiles])

    const onClick = (route: string) => {
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        sideContext.setSelectedPanelValue(route);
    }

    const activeSubControl = (cmd: string) => {
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(cmd);
    }

    const findObjMeshGroup = (uuid: string) => {
        console.log('first', graphicStore.extraContext.sceneContext.scene.children)
        let objMeshGroup = graphicStore.extraContext.sceneContext.scene.children.find(item => item.uuid == uuid);
        return objMeshGroup;
    }


    const loadingMultipleObjsAndMtl = (
        mtlUrl: string,
        objList: ObjModelInfo[]
    ) => {
        if (!graphicStore.extraContext.sceneContext.scene) return;

        const scene = graphicStore.extraContext.sceneContext.scene;
        const key = 'uploading';
        const total = objList.length;
        let loaded = 0;
        const uuids: string[] = [];
        const uuidMap: { [key: string]: string } = {};

        message.loading({ content: `开始加载模型 0%`, key, duration: 0 });

        const progressList = new Array(objList.length).fill(0); // 每个模型加载进度（0~100）

        const updateOverallProgress = () => {
            const average = progressList.reduce((a, b) => a + b, 0) / objList.length;
            const key = 'uploading';
            message.loading({
                content: `正在加载所有模型 ${average.toFixed(2)}%`,
                key,
                duration: 0
            });
        };

        new MTLLoader().load(mtlUrl, (materials) => {
            materials.preload();
            const objLoader = new OBJLoader().setMaterials(materials);

            objList.forEach(({ objUrl, position, scale, rotation, uuid }, index) => {
                objLoader.load(
                    objUrl,
                    (object) => {
                        console.log('加载了一个obj', object)
                        scene.add(object);

                        if (position) object.position.set(position.x, position.y, position.z);
                        if (scale) object.scale.set(scale.x, scale.y, scale.z);
                        if (rotation) object.quaternion.set(rotation.x, rotation.y, rotation.z, rotation.w ?? 1);

                        uuids.push(object.uuid); // 收集 UUID
                        uuidMap[uuid] = object.uuid; // 收集 UUID 对应关系

                        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners?.signals?.needRender?.dispatch();

                        loaded++;

                        if (loaded === total) {
                            systemContext.setCurrentObjMeshGroupUuidMap(uuidMap);
                            systemContext.setCurrentObjMeshGroupUuids(uuids); // 统一设置
                            message.success({ content: `所有模型加载完毕`, key, duration: 2 });
                        }
                    },
                    (event: ProgressEvent) => {
                        if (event.lengthComputable) {
                            const percent = (event.loaded / event.total) * 100;
                            progressList[index] = percent;
                            updateOverallProgress();
                        }
                    },
                    (error) => {
                        console.error(`加载失败: ${objUrl}`, error);
                        loaded++;

                        if (loaded === total) {
                            systemContext.setCurrentObjMeshGroupUuidMap(uuidMap);
                            systemContext.setCurrentObjMeshGroupUuids(uuids); // 统一设置（即使部分失败）
                            message.success({ content: `部分模型加载完毕`, key, duration: 2 });
                        }
                    }
                );
            });
        });

    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // 显示上传中提示
        const key = 'uploading';
        message.loading({ content: '正在上传...', key, duration: 0 });

        try {
            const now = new Date();
            const yyyy = now.getFullYear();
            const MM = String(now.getMonth() + 1).padStart(2, '0');
            const dd = String(now.getDate()).padStart(2, '0');
            const HH = String(now.getHours()).padStart(2, '0');
            const folderName = `${projectUuid}/${yyyy}${MM}${dd}${HH}/`;
            const newName = genUUID();
            const res = await uploadFileObject(file, file.name, {
                bucketName: "station-maint-pub", isOrigin: true,
                folderName: folderName, coverName: newName
            }); // 第二个参数是 MinIO 中的路径（可自定义）
            console.log('上传成功：', res);
            message.success({ content: '上传成功', key, duration: 2 });

            message.loading({ content: '正在解压...', key, duration: 0 });

            let hasFind = false;
            (systemContext.objFiles || []).forEach(obj => {
                const objUuid = systemContext.currentObjMeshGroupUuidMap[obj.uuid];
                if (!objUuid) return;
                const oldObj = findObjMeshGroup(objUuid);
                if (oldObj) {
                    const scene = graphicStore.extraContext.sceneContext.scene;
                    scene.remove(oldObj);
                }
            })
            if (hasFind) {
                graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.needRender.dispatch();
            }

            resolveObjFiles(res.data.fileName, projectUuid, { bucketName: "station-maint-pub" }).then((resInner) => {
                console.log("resInner", resInner)
                message.success({ content: '解压成功', key, duration: 2 });
                const list = resInner.data || [];
                const obj = list[0];
                systemContext.setObjFiles(list);

                const objs: ObjModelInfo[] = [];
                list.forEach(objFile => {
                    objs.push({ objUrl: objFile.objFilePath, uuid: objFile.uuid });
                })

                loadingMultipleObjsAndMtl(obj.mtlFilePath, objs);
            })
        } catch (err) {
            console.error('上传失败', err);
            message.error({ content: '上传失败', key });
        } finally {
            // 清空 input，以便下次选择同一个文件时也能触发 onChange
            e.target.value = '';
        }
    };

    const triggerFileInput = () => {
        const input = document.getElementById('import-obj-and-mtl') as HTMLInputElement;
        input?.click();
    };

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><GaochengdianSvg /></div>
                                <div className='name'>高程点</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><DenggaoxianSvg /></div>
                                <div className='name'>等高线</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><HeliuSvg /></div>
                                <div className='name'>河流</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><HupoSvg /></div>
                                <div className='name'>湖泊</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ZhaozeSvg /></div>
                                <div className='name'>沼泽</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ShanSvg /></div>
                                <div className='name'>山</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><CaodiSvg /></div>
                                <div className='name'>草地</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ShamoSvg /></div>
                                <div className='name'>沙地</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ShulinSvg /></div>
                                <div className='name'>树林</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><GengdiSvg /></div>
                                <div className='name'>耕地</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.tree) }}>
                                <div className='icon'><QiaoguanmuSvg /></div>
                                <div className='name'>乔灌木</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.road_network) }}>
                                <div className='icon'><LuwangSvg /></div>
                                <div className='name'>路网</div>
                            </div>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.road) }}>
                                <div className='icon'><DaoluSvg /></div>
                                <div className='name'>道路</div>
                            </div>
                            <div className='ope-item' onClick={() => { activeSubControl("LANEINTERSECTION") }}>
                                <div className='icon'><JiaochakouSvg /></div>
                                <div className='name'>交叉路口</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><QiaoliangSvg /></div>
                                <div className='name'>桥梁</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><SuidaoSvg /></div>
                                <div className='name'>隧道</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><HandongSvg /></div>
                                <div className='name'>涵洞</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.street_lamp) }}>
                                <div className='icon'><LudengSvg /></div>
                                <div className='name'>路灯</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.fence) }}>
                                <div className='icon'><WeiqiangSvg /></div>
                                <div className='name'>围墙</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><JianzhuwuSvg /></div>
                                <div className='name'>建筑物</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><GouzhuwuSvg /></div>
                                <div className='name'>构筑物</div>
                            </div>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.ground) }}>
                                <div className='icon'><DimianSvg /></div>
                                <div className='name'>硬化地面</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.parking_space) }}>
                                <div className='icon'><JidongcheweiSvg /></div>
                                <div className='name'>机动车位</div>
                            </div>
                            <div className='ope-item name5' onClick={() => { onClick(SIDE_TYPE.no_motor_parking_space) }}>
                                <div className='icon'><FeijidongcheweiSvg /></div>
                                <div className='name'>非机动车位</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ChurukouSvg /></div>
                                <div className='name'>出入口</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><LinshiweidangSvg /></div>
                                <div className='name'>临时围挡</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><LinshidaoluSvg /></div>
                                <div className='name'>临时道路</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><LinshifangwuSvg /></div>
                                <div className='name'>临时房屋</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item' onClick={triggerFileInput}>
                                <div className='icon'><UploadBlackSvg /></div>
                                <div className='name'>上传</div>
                                <input type="file" accept=".zip,.rar,.7z" id="import-obj-and-mtl" onChange={handleFileChange} style={{ display: 'none' }} />
                            </div>

                            <div className='ope-item' onClick={() => {
                                getObjFiles(projectUuid).then(res => {
                                    console.log(res.data);
                                    let objFiles = res.data;
                                    if (objFiles == null || objFiles.length == 0) {
                                        return;
                                    }
                                    systemContext.setObjFiles(objFiles);

                                    const obj = objFiles[0];
                                    const objs: ObjModelInfo[] = [];
                                    objFiles.forEach(objFile => {
                                        objs.push({
                                            objUrl: objFile.objFilePath,
                                            position: objFile.position,
                                            scale: objFile.scale,
                                            rotation: objFile.rotation,
                                            uuid: objFile.uuid
                                        });
                                    })

                                    loadingMultipleObjsAndMtl(obj.mtlFilePath, objs);
                                })
                            }}>
                                <div className='icon'><UploadBlackSvg /></div>
                                <div className='name'>加载</div>
                            </div>

                            <div className='ope-item' onClick={() => {
                                let hasFind = false;
                                systemContext.objFiles.forEach(obj => {
                                    const objUuid = systemContext.currentObjMeshGroupUuidMap[obj.uuid];
                                    if (!objUuid) return;
                                    const objMeshGroup = findObjMeshGroup(objUuid);
                                    if (objMeshGroup) {
                                        objMeshGroup.visible = !objMeshGroup.visible;
                                        hasFind = true;
                                    }
                                })
                                if (hasFind) {
                                    graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.needRender.dispatch();
                                }
                            }}>
                                <div className='icon'><UploadBlackSvg /></div>
                                <div className='name'>显隐</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item' onClick={() => {
                                activeSubControl("OBJ_MESH_GROUP_MOVE");
                                (graphicStore.extraContext.getCurrentViewEditor()?.cmdControl.currentControl as ObjMeshGroupMoveControl).objMeshGroupUuids = systemContext.currentObjMeshGroupUuids;
                            }}>
                                <div className='icon'><UploadBlackSvg /></div>
                                <div className='name'>场景平移</div>
                            </div>
                            <div className='ope-item' onClick={() => {
                                activeSubControl("OBJ_MESH_GROUP_ROTATE");
                                (graphicStore.extraContext.getCurrentViewEditor()?.cmdControl.currentControl as ObjMeshGroupMoveControl).objMeshGroupUuids = systemContext.currentObjMeshGroupUuids;
                            }}>
                                <div className='icon'><UploadBlackSvg /></div>
                                <div className='name'>场景旋转</div>
                            </div>
                            <div className='ope-item' onClick={() => {
                                activeSubControl("OBJ_MESH_GROUP_SCALE");
                                (graphicStore.extraContext.getCurrentViewEditor()?.cmdControl.currentControl as ObjMeshGroupMoveControl).objMeshGroupUuids = systemContext.currentObjMeshGroupUuids;
                            }}>
                                <div className='icon'><UploadBlackSvg /></div>
                                <div className='name'>场景缩放</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}